import { styled } from "@mui/material/styles";
import type { CSSObject } from "@mui/material/styles";

import { Popover } from "@mui/material";

// sx is spread into styled callback for override support; cast to CSSObject satisfies the styled return type
export const LiPopover = styled(Popover)<{ sx?: Record<string, unknown> }>(
    ({ sx }) =>
        ({
            "& > div ": { boxShadow: `rgba(0, 0, 0, 0.24) 0px 3px 5px !important;` },
            ...sx,
        }) as CSSObject
);
